import styled from "styled-components";

export const StyledConfigExternalCollaboratorModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  & .form-row {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    column-gap: 20px;
    row-gap: 20px;
    gap: 20px;

    & > section {
      width: 380px;
    }
  }

  & .collaboratorAdd {
    margin-bottom: 200px;
  }
`;
